import {App as StdApp} from "@std/app";

export class App extends StdApp {
    constructor(config = {}) {
        super(config);
    }

    run() {}
}

import "@main/components/scroll-lock";
import "@main/components/modal";
import "@main/components/form-validation";
import "@main/components/cookies";
import "@main/components/testing";
import "@main/components/page-nav";
import "@main/components/notifications";
import "@main/components/tabs";
import "@main/components/sort";
import "@main/components/filter";
import "@main/components/test-list";
import "@main/components/copy-link";
import "@main/components/set-test-id";
import "@main/components/add-link-form";
import "@main/components/input-select";
import "@main/components/results";
import "@main/components/toggle";
import "@main/components/statistic";
import "@main/components/archive";
